import {debounce} from "@pg-mono/nodash";

import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/init_google_tag_manager";
import {YslabEvents, YslabEventTypes, YslabJeffAppEventTypes} from "./types/YslabEventTypes";

type YslabEvent = Omit<YslabEvents, "type"> & {
    event: YslabEventTypes | YslabJeffAppEventTypes;
};

const trackYslabEvent = (event: YslabEvents) => {
    const yslabEvent: YslabEvent = {
        ...event,
        event: event.data.type
    };

    hitGoogleTagManager(yslabEvent);
};

export const debouncedTrackYslabEvent = debounce(trackYslabEvent, 500);
import {debounce} from "@pg-mono/nodash";

import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/init_google_tag_manager";
import {YslabEvents, YslabEventTypes, YslabJeffAppEventTypes} from "./types/YslabEventTypes";

type YslabEvent = Omit<YslabEvents, "type"> & {
    event: YslabEventTypes | YslabJeffAppEventTypes;
};

const trackYslabEvent = (event: YslabEvents) => {
    const yslabEvent: YslabEvent = {
        ...event,
        event: event.data.type
    };

    hitGoogleTagManager(yslabEvent);
};

export const debouncedTrackYslabEvent = debounce(trackYslabEvent, 500);
